module.exports = __webpack_public_path__ + "img/map-hours-table-red.1e616433.png";